var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewYearPrivateModeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84534 19.9562C4.81876 19.9562 3.98355 19.1207 3.98355 18.0944C3.98355 17.0679 4.81876 16.2326 5.84534 16.2326C6.87192 16.2326 7.70713 17.068 7.70713 18.0944C7.70713 19.1208 6.87192 19.9562 5.84534 19.9562Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.096
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1525 19.9562C13.1259 19.9562 12.2907 19.1207 12.2907 18.0944C12.2907 17.0679 13.1261 16.2326 14.1525 16.2326C15.1789 16.2326 16.0143 17.068 16.0143 18.0944C16.0143 19.1208 15.179 19.9562 14.1525 19.9562Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.096
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33066 17.7218L7.33066 17.7218C9.12605 16.6891 10.8898 16.8204 12.6685 17.8447L12.6924 17.8032L12.6685 17.8447C13.0051 18.0386 12.8663 18.557 12.4779 18.557H12.4722C12.4294 18.5553 12.3645 18.5341 12.2728 18.4936C12.202 18.4623 12.1203 18.4219 12.0266 18.3757C11.9959 18.3606 11.964 18.3448 11.9307 18.3285C11.6626 18.1972 11.3171 18.0362 10.905 17.9212C10.079 17.6906 8.98805 17.6457 7.71125 18.3832C7.60069 18.4471 7.49648 18.4516 7.40858 18.4218C7.31951 18.3915 7.24376 18.3246 7.19501 18.2403C7.14626 18.156 7.12617 18.0571 7.14461 17.965C7.1628 17.874 7.21916 17.786 7.33066 17.7218Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.096
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9888 11.7229C17.9277 12.6223 20.9084 7.32582 20.9084 7.32582L20.1633 6.32639C19.0422 8.64166 17.2916 7.70613 16.3478 6.94306C15.997 6.65937 15.728 6.30267 15.5154 5.91645C14.7177 4.4679 12.392 3.62817 12.392 3.62817L8.87891 9.22455L13.9888 11.7229Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80978 10.5956C1.80978 10.5956 5.11351 3.7918 6.42682 1.78813C9.50761 -2.91202 14.1887 2.56802 16.3641 7.69493C16.7386 8.57778 17.0122 9.54887 17.1085 10.5956C17.1085 10.5956 1.43668 10.8574 1.80978 10.5956Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41119 13.502C13.5047 13.502 16.5444 12.9832 18.5176 12.1528C19.7701 11.6257 18.9117 9.23071 17.5941 9.23071H2.09483C0.785653 9.23071 -0.78891 11.6014 0.449966 12.1466C2.34475 12.9806 5.30767 13.502 9.41119 13.502Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.67756C24 6.8094 23.0226 7.72694 21.8169 7.72694C20.6112 7.72694 19.6338 6.8094 19.6338 5.67756C19.6338 4.54571 20.6112 3.62817 21.8169 3.62817C23.0226 3.62817 24 4.54571 24 5.67756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYearPrivateModeOff);
export default __webpack_public_path__ + "static/media/newYearPrivateModeOff.6ff5e078ece689f755b7e95fdbb44e14.svg";
export { ForwardRef as ReactComponent };